import { render, staticRenderFns } from "./WhySection.vue?vue&type=template&id=6c9254b4&scoped=true&"
import script from "./WhySection.vue?vue&type=script&lang=js&"
export * from "./WhySection.vue?vue&type=script&lang=js&"
import style0 from "./WhySection.vue?vue&type=style&index=0&id=6c9254b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9254b4",
  null
  
)

export default component.exports